import React from "react";
import styled from "styled-components";
// import Image1 from "../images/";
// import Image2 from "../images/";
// import Image3 from "../images/";
// import Image4 from "../images/";

const Trending = () => {
  return (
    <Container>
      <h4>Trending</h4>
      <Content>
        <Wrap>
          <img
            src="https://www.washingtonpost.com/graphics/2019/entertainment/oscar-nominees-movie-poster-design/img/black-panther-web.jpg"
            alt="MovieImage"
          />
        </Wrap>
        <Wrap>
          <img
            src="https://media.comicbook.com/2017/10/iron-man-movie-poster-marvel-cinematic-universe-1038878.jpg"
            alt="MovieImage"
          />
        </Wrap>{" "}
        <Wrap>
          <img
            src="https://cdnb.artstation.com/p/assets/images/images/011/694/837/large/editician-zone-editician-zone-113.jpg?1530897875"
            alt="MovieImage"
          />
        </Wrap>{" "}
        <Wrap>
          <img
            src="https://graphicdesignjunction.com/wp-content/uploads/2016/01/001-movie-poster.jpg"
            alt="MovieImage"
          />
        </Wrap>
      </Content>
    </Container>
  );
};

export default Trending;
const Container = styled.div`
  padding: 0 0 26px;
`;
const Content = styled.div`
  display: grid;
  grid-gap: 25px;
  gap: 25px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
const Wrap = styled.div`
  margin-top: 15px;
  padding-top: 56.25%;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  border: 3px solid rgba(249, 249, 249, 0.1);
  img {
    inset: 0px;
    display: block;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    position: absolute;
    transition: opacity 500ms ease-in-out 0s;
    width: 100%;
    z-index: 1;
    top: 0;
  }
  &:hover {
    transform: scale(1.05);
    border-color: rgba(249, 249, 249, 0.8);
  }
`;
